<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="费用"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="应收状态：" prop="paymentStatus">
          <el-select size="mini" v-model="form.paymentStatus">
            <el-option
              v-for="item in wxfsfztDicts"
              :key="item.dictionaryCode"
              :label="item.dictionaryValue"
              :value="item.dictionaryCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应收金额：" prop="receivableAmount" class="mr0">
          <el-input
            size="mini"
            v-model.trim="form.receivableAmount"
            v-number-only:20="2"
            placeholder="请输入应收金额"
            clearable
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item label="应收日期：" prop="receivableTime">
          <el-date-picker
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            prefix-icon=" "
            value-format="yyyy-MM-dd"
            placeholder="请选择应收日期"
            v-model.trim="form.receivableTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="收款人：" prop="receiverId" class="mr0">
          <el-select
            size="mini"
            v-model="form.receiverId"
            filterable
            placeholder="请选择收款人"
            clearable
            reserve-keyword
            :remote="true"
            collapse-tags
            :remote-method="searchUserList"
            @visible-change="searchUserList('')"
          >
            <el-option
              v-for="item in userList"
              :key="item.userId"
              :label="item.nickname"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同附件：" class="input-with-col2 mr0">
          <UploadAttachments @createFile="createFile" @deleteFile="deleteFile" :fileName="form.attachmentName"/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { getUserSimpleList } from "@/api/MaintenancePlan";
import { setFee } from "@/api/MaintenanceFeeConfirmation";
import UploadAttachments from "@/components/UploadAttachments"

export default {
  data() {
    return {
      form: {
        liftId: null,
        projectId: null,
        projectName: "",
        receivableAmount: null,
        receivableTime: "",
        receivableWay: "",
        receiverId: "",
        paymentStatus: "",
        feeType: null,
        amount: null,
        attachmentName: '',
        attachmentPath: ''
      },
      rules: {
        paymentStatus: [
          {
            required: true,
            message: "请选择应收状态",
            trigger: "change",
          },
        ],
        receivableAmount: [
          {
            required: true,
            message: "请输入应收金额",
            trigger: "blur",
          },
        ],
        receivableTime: [
          {
            required: true,
            message: "请选择应收收日期",
            trigger: "change",
          },
        ],
        receiverId: [
          {
            required: true,
            message: "请选择收款人",
            trigger: "change",
          },
        ],
      },
      loadBtn: false,
      
      userList: [],
    };
	},
  props:['editData'],
  components: {
    UploadAttachments
  },
  computed: {
    ...mapState("common/dictionary", ["wxffylxDicts", "wxfsfztDicts"]),
  },
  created() {
		this.form = {...this.editData}
		this.searchUserList('')
	},
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const params = { ...this.form };
          params.receiverId = params.receiverId * 1;
          params.projectId = params.projectId * 1;
          params.feeType = params.feeType * 1;
          params.liftId = params.liftId * 1;
          params.amount = params.amount * 1;
          params.receivableWay = params.receivableWay * 1;
          params.receivableAmount = params.receivableAmount * 1;
          params.paymentStatus = params.paymentStatus * 1;
          const res = await setFee(params);
          if (res.code === 200) {
            this.$message.success("编辑成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
    async searchUserList(keyword) {
      const res = await getUserSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.userList = res.data;
      }
    },
    chooseProject(val) {
      if (val && val.id) {
        this.form.projectId = val.id;
        this.form.projectName = val.projectName;
      } else {
        this.form.projectId = "";
        this.form.projectName = "";
      }
    },
    createFile(res) {
      this.form.attachment = res.reourceAddress;
      this.form.attachmentName = res.fileName;
    },
    deleteFile() {
      this.form.attachment = '';
      this.form.attachmentName = '';
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/MaintenanceFeeConfirmation/components/editDialog.vue